import { Component, OnInit, Input, OnChanges } from '@angular/core';

export interface FaqData {
  Titulo: string;
  Descricao: string;
}

@Component({
  selector: 'fcp-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnChanges {
  @Input() public data: any;
  public step = 0;

  constructor() {}

  ngOnChanges(changes) {
    if (this.data?.content?.length) {
      this.data.content.forEach((item: FaqData) => {
        if (item.Descricao) {
          item.Descricao = item.Descricao.replace(
            /<table/gi,
            '<div class="responsive-table"><table'
          ).replace(/<\/table>/gi, '</table></div>');
        }
        return item;
      });
    }

    if (this.data?.title === null) {
      this.data.title = this.data.title
        ? this.data.title
        : `<h3>Perguntas mais buscadas</h3>`;
    }
  }

  ngOnInit() {}

  public setStep(index: number) {
    this.step = index;
  }

  public nextStep() {
    this.step++;
  }

  public prevStep() {
    this.step--;
  }
}
